let Environment = {
  saleContractAddress: "0xD055c32af3625e110cDAeF823F306C99768B4041",
  defaultAddress: "0x607541193dd9f7d3409f97b587ee3ab3d515c271",
};

export default Environment;
